import {
    GET_DOCUMENT_SERIES,
    GET_DOCUMENT_SERIES_DETAILS,
    CREATE_DOCUMENT_SERIES,
    UPDATE_DOCUMENT_SERIES,
    DELETE_DOCUMENT_SERIES,
    PREVIEW_DOCUMENT_SERIES_NUMBER
} from '../../index.types';


export function getDocumentSeries(data) {
    return {
        type: GET_DOCUMENT_SERIES,
        data
    }
}

export function getDocumentSeriesDetails(data) {
    return {
        type: GET_DOCUMENT_SERIES_DETAILS,
        data
    }
}

export function createDocumentSeries(data) {
    return {
        type: CREATE_DOCUMENT_SERIES,
        data
    }
}

export function updateDocumentSeries(data) {
    return {
        type: UPDATE_DOCUMENT_SERIES,
        data
    }
}

export function deleteDocumentSeries(data) {
    return {
        type: DELETE_DOCUMENT_SERIES,
        data
    }
}

export function previewDocumentSeriesNumber(data) {
    return {
        type: PREVIEW_DOCUMENT_SERIES_NUMBER,
        data
    }
}
